(function(){
    'use strict';
    angular
        .module('completeAir')
        .config(stateConfig)

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('specialConnections',{
                parent: 'app',
                url: "/specialConnections?date",
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    date: null
                },
                views:{
                    'main@':{
                        'templateUrl' : 'app/admin/configGeneral/adminFlight/specialConnection/specialConnections.html',
                        'controller' : 'specialConnectionCtrl',
                        'controllerAs' : 'vm',
                        'resolve' : {
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabAdminFlights('specialConnections')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['adminConnection']);
                            }],
                            'connections' : ['specialConnectionService','$stateParams',
                                function(specialConnectionService, $stateParams){
                                    if ($stateParams.date == null) {
                                        $stateParams.date = (new Date()).getTime();
                                    }
                                    return specialConnectionService.getConnections(parseInt($stateParams.date));
                            }]

                        }
                    }
                }
            })
            .state('specialConnectionNew', {
                parent: 'app',
                url: '/specialConnection/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/adminFlight/specialConnection/specialConnectionNew.html',
                        controller: 'newSpecialConnectionCtrl',
                        controllerAs: 'vm',
                        'resolve': {
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabAdminFlights('specialConnections')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['adminConnection']);
                            }]
                        }
                    }
                }
            })
            .state('specialConnectionDelete',{
                parent: 'specialConnections',
                url: '/specialConnection/:connectionId/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams','$state','$uibModal', function($stateParams,$state,$uibModal){
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/adminFlight/specialConnection/specialConnectionDelete.html',
                        controller: 'deleteSpecialConnectionCtrl',
                        controllerAs: 'vm',
                        size: 'md'
                    }).result.then(function() {
                        $state.go('specialConnections', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
    }
})();
